import { CSSProperties } from "react";
import styled from "@emotion/styled";
import { GrPagination, GrSelect, GrStack, GrTypography, palette } from "@jnpmedi/grebob";
import classNames from "classnames";
import { DocsTableSizeType } from "./DocsTable";

export const DEFAULT_PAGE = 1;
export const DEFAULT_RECORD_PER_PAGE = 25;

export type PaginationProps = {
  page: number;
  rpp: number;
  count: number | bigint;
};

export type DocsTablePaginationProps = {
  pagination?: PaginationProps;
  onChangePage: (page: number) => void;
  onChangeRowsPerPage: (rpp: number) => void;
  hasRppSelect?: boolean;
  rppOptions?: number[];
  size?: DocsTableSizeType;
  className?: string;
  style?: CSSProperties;
};

export function DocsTablePagination({
  pagination,
  onChangePage,
  onChangeRowsPerPage,
  hasRppSelect = true,
  rppOptions = [10, 25, 50],
  size = "medium",
  className,
  style,
}: DocsTablePaginationProps) {
  if (!pagination) {
    return <DocsTablePaginationWrapper size={size} style={style} className={classNames("DocsTablePagination", className)} />;
  }

  const { page = DEFAULT_PAGE, rpp = DEFAULT_RECORD_PER_PAGE, count = 0 } = pagination;

  return (
    <DocsTablePaginationWrapper size={size} style={{ ...(style ?? {}) }} className={classNames("DocsTablePagination", className)}>
      {hasRppSelect && (
        <StyledRppOptionWrapper>
          <GrTypography type="Content.Caption02" color="grey070">
            View
          </GrTypography>
          <GrSelect<number, false, true>
            size="small"
            value={rpp}
            options={rppOptions}
            onChange={(_, v) => onChangeRowsPerPage(v)}
            style={{ width: "72px" }}
          />
          <GrTypography type="Content.Caption02" color="grey070">
            Rows
          </GrTypography>
        </StyledRppOptionWrapper>
      )}

      <GrStack alignItems="center" justifyContent="center" style={{ flex: "1" }}>
        <GrPagination page={page} count={Math.ceil((Number(count) || 1) / rpp)} size="medium" onChange={(_, v) => onChangePage(v)} />
      </GrStack>
    </DocsTablePaginationWrapper>
  );
}

const DocsTablePaginationWrapper = styled(GrStack)<{ size?: DocsTableSizeType }>(({ size }) => ({
  position: "relative",
  width: "100%",
  height: size === "small" ? "40px" : "55px",
  boxSizing: "border-box",
  padding: size === "small" ? "8px 0px" : "15px 0px",
  alignItems: "center",
  backgroundColor: palette["white"],
  borderRadius: "0px 0px 6px 6px",
  borderTop: `1px solid ${palette["grey025"]}`,
  userSelect: "none",
}));

const StyledRppOptionWrapper = styled(GrStack)({
  position: "absolute",
  zIndex: 1,
  gap: "8px",
  padding: "0px 16px",
  alignItems: "center",
});
